import React from 'react'
import BmpTable from './BmpTable'
import { getAssignments } from 'pif-preview'
import { PifSelectorProps } from './PifSelector'

export const PifBmpTable: React.FC<PifSelectorProps> = props => {
	const { pifItems, coords, hierarchies } = props

	if (!coords.formType) return null

	let pif = pifItems.find(pif => pif.formId == coords.pifId)

	if (!pif) return null

	return (
		<div>
			This Form is assigned to these BMPs:
			<BmpTable deployments={getAssignments(pif, coords.formType)} projectCategories={hierarchies.bmps} intakes={hierarchies.intakes} />
		</div>
	)
}
